import './Empty.scss';

export { default } from './Empty';
